import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { TabsSelectorComponent } from "../ModalContent/TabsSelectorComponent";
import { UpdateOrderTexts } from "../deliveryModalUtils/const-enums-types";
import { ExtraSmallFab } from "../../../Shared/components/Buttons/ExtraSmallFAB";
/**
 * A small abstraction to make the component more readable.
 *
 */
export const Title = (props) => {
    if (props.showAddresses)
        return _jsx(TabsSelectorComponent, Object.assign({}, props));
    else
        return _jsx(Typography, Object.assign({ variant: "h2" }, { children: UpdateOrderTexts.UPDATE_DELIVERY }));
};
/**
 * TitleComponent is a wrapper around the Title component that includes a close button.
 */
export const TitleComponent = (props) => {
    return (_jsxs(Stack, Object.assign({ direction: "row", justifyContent: "space-between", alignItems: "center" }, { children: [_jsx(Title, Object.assign({}, props)), _jsx(ExtraSmallFab, { icon: CloseIcon, "aria-label": "close", onClick: props.onClose })] })));
};
